import { createReducer, on } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';
import { FullscreenActions, MainSidecarActions, SidecarEfffectActions } from '@src/suite/common/store/fullscreen/actions/fullscreen.actions';
import { SidecarMenu, SidecarState } from '@src/suite/common/store/fullscreen/models/fullscreen.models';

import { BASE_SIDECAR_INITIAL_STATE } from './fullscreen.reducer';

export const mainSidecarInitialState: SidecarState = {
    ...BASE_SIDECAR_INITIAL_STATE,
};

export const mainSidecarReducer = createReducer(
    mainSidecarInitialState,
    on(
        FullscreenActions.resetState,
        (): SidecarState => ({
            ...mainSidecarInitialState,
        })
    ),
    on(
        MainSidecarActions.selectSidecarMenu,
        (state, { menu }): SidecarState => ({
            ...state,
            selected: menu,
        })
    ),
    on(
        MainSidecarActions.selectSidecarAssignment,
        (state, { assignmentGuid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.ASSIGNMENTS,
            selectedAssignmentGuid: assignmentGuid,
        })
    ),
    on(
        MainSidecarActions.selectSidecarDiscoverItem,
        (state, { guid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.DISCOVER_ITEMS,
            selectedDiscoverItemGuid: guid,
        })
    ),
    on(MainSidecarActions.setAssignmentViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedAssignmentViewStates: viewStates,
        };
    }),
    on(MainSidecarActions.setCurrentAssignmentViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentAssignmentViewStateGuid: guid || null,
        };
    }),
    on(MainSidecarActions.setAssignmentListGuids, (state, { assignmentGuids }): SidecarState => {
        return {
            ...state,
            assignmentListGuids: assignmentGuids,
        };
    }),
    on(MainSidecarActions.setTopicViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedTopicViewStates: viewStates,
        };
    }),
    on(MainSidecarActions.setCurrentTopicViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicViewStateGuid: guid || null,
        };
    }),
    on(MainSidecarActions.setTopicListGuids, (state, { topicGuids }): SidecarState => {
        return {
            ...state,
            topicListGuids: topicGuids,
        };
    }),
    on(MainSidecarActions.setRundownViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedRundownViewStates: viewStates,
        };
    }),
    on(MainSidecarActions.setCurrentRundownViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownViewStateGuid: guid || null,
        };
    }),
    on(MainSidecarActions.setRundownListGuids, (state, { rundownGuids }): SidecarState => {
        return {
            ...state,
            rundownListGuids: rundownGuids,
        };
    }),
    on(
        MainSidecarActions.selectSidecarStory,
        (state, { guid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.STORIES,
            selectedStoryGuid: guid,
        })
    ),
    on(MainSidecarActions.setStoryViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedStoryViewStates: viewStates,
        };
    }),
    on(MainSidecarActions.setCurrentStoryViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentStoryViewStateGuid: guid || null,
        };
    }),
    on(MainSidecarActions.setStoryListGuids, (state, { storyGuids }): SidecarState => {
        return {
            ...state,
            storyListGuids: storyGuids,
        };
    }),
    on(MainSidecarActions.selectSidecarRundown, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedRundownGuid: guid,
        };
    }),
    on(MainSidecarActions.selectSidecarTopic, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedTopicGuid: guid,
        };
    }),
    on(MainSidecarActions.setCurrentROSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownSelectedStoryGuid: guid,
        };
    }),
    on(MainSidecarActions.setCurrentTopicSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedStoryGuid: guid,
        };
    }),
    on(MainSidecarActions.setCurrentTopicSelectedAssignment, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedAssignmentGuid: guid,
        };
    }),
    on(
        MainSidecarActions.setCurrentMosPlugin,
        (state, { mosPluginId: mosId }): SidecarState => ({
            ...state,
            selectedMosPluginID: mosId,
            selectedMosPluginInitialized: false,
            selectedMosPluginPendingCommand: null,
        })
    ),
    on(
        MainSidecarActions.resetMosState,
        (state): SidecarState => ({
            ...state,
            selectedMosPluginID: null,
            selectedMosPluginInitialized: false,
            selectedMosPluginPendingCommand: null,
        })
    ),
    on(
        MainSidecarActions.setAssignmentsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedAssignmentListSearchType: searchType,
        })
    ),
    on(
        MainSidecarActions.setStoriesListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedStoryListSearchType: searchType,
        })
    ),
    on(
        MainSidecarActions.setTopicsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedTopicListSearchType: searchType,
        })
    ),
    on(
        MainSidecarActions.setRundownsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedRundownListSearchType: searchType,
        })
    ),
    on(SidecarEfffectActions.openMosItemInSidecar, (state, { mosPluginId, mosItemCommand, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_MAIN) {
            return {
                ...state,
                selectedMosPluginID: mosPluginId,
                selectedMosPluginPendingCommand: mosItemCommand,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openPendingMosItem, (state, { mosPluginId, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_MAIN && mosPluginId === state.selectedMosPluginID) {
            return {
                ...state,
                selectedMosPluginPendingCommand: null,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentMosPluginInitialized, (state, { mosPluginId, sidecar }): SidecarState => {
        if (mosPluginId === state.selectedMosPluginID && sidecar === FullscreenLayoutAreas.SIDECAR_MAIN) {
            return {
                ...state,
                selectedMosPluginInitialized: true,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setRundownLayout, (state, { roGuid, layout, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_MAIN) {
            const rundownState = new Map(state.rundownState);
            rundownState.set(roGuid, { selectedLayoutName: layout.name, selectedLayoutType: layout.type });
            return {
                ...state,
                rundownState,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openSubStoriesInSidecar, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_MAIN) {
            return { ...state, subStoriesParentGuid: parentGuid || null };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentSubStories, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_MAIN) {
            return { ...state, subStoriesParentGuid: parentGuid };
        }
        return state;
    }),
    on(SidecarEfffectActions.clearStoryFromSidecar, (state, { sidecar, excludedMenus }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_MAIN) {
            const newState = {
                ...state,
            };
            if (excludedMenus?.length) {
                excludedMenus.forEach(menu => {
                    switch (menu) {
                        case SidecarMenu.STORIES:
                            newState.currentRundownSelectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.RUNDOWNS:
                            newState.selectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.TOPICS:
                            newState.selectedStoryGuid = null;
                            newState.currentRundownSelectedStoryGuid = null;
                            break;
                    }
                });
                return newState;
            }
            newState.selectedStoryGuid = null;
            newState.currentRundownSelectedStoryGuid = null;
            newState.currentTopicSelectedStoryGuid = null;
            return newState;
        }
        return state;
    })
);
